import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'help-link',
  templateUrl: './help-link.component.html',
  styleUrls: ['./help-link.component.scss']
})
export class HelpLinkComponent implements OnInit {

  helpUrl: string;

  @Input()
  path: string;
  constructor() { }

  ngOnInit() {
    this.helpUrl = this.path;
  }
}
